import React from "react";
import { Helmet } from "react-helmet";

interface MetadataProps {
  title?: string;
  description?: string;
  url?: string;
  image?: string;
}

const Metadata: React.FC<MetadataProps> = ({
  title,
  description,
  image,
}) => {
  const newTitle = title ? title : "Lighthouse Storage";
  const newDescription = description
    ? description
    : "Store Files Perpetually on IPFS and Filecoin";
  const newImage = image ? image : "";

  return (
    <Helmet>
      {/* Primary Meta Tags  */}
      <title>{newTitle}</title>
      <meta name="title" content={newTitle} />
      <meta name="description" content={newDescription} />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="color-scheme" content="dark" />
      <meta name="author" content="Lighthouse" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@LighthouseWeb3" />
      <meta name="twitter:creator" content="@LighthouseWeb3" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Lighthouse Storage" />

      <meta
        property="og:url"
        content={`${window.location.href}`}
        key="og-url"
      />
      <meta property="og:title" content={newTitle} />
      <meta property="og:description" content={newDescription} />
      <meta property="og:image" content={newImage} />
    </Helmet>
  );
};

export default Metadata;
